import { RowSystemDto } from "@/dtos";
import { Systems } from "@/entities";

export const formatRowSystemDto = (systems: Systems[]): RowSystemDto[] => {
    return systems.map(x => {
        const row: RowSystemDto = {
            ...x,
            totalCompanies: x.system_companies.length,
            quota_value: '$ ' + (x.quota / 100).toFixed(2),
            quota_balance: '$ ' + (x.balance / 100).toFixed(2)
        }

        return row;
    });
}